import { Library, Music2, Wand2 } from 'lucide-react'
import { Link, useOutletContext } from 'react-router-dom'
import { useEffect } from 'react'
import type { AdminOutletContext } from '../layouts/AdminLayout'
import styles from './ToolsPage.module.css'

const tools: Array<{
  id: 'track_titles' | 'suno_style_prompts' | 'prompt_library'
  icon: typeof Wand2
  href: string
  title: string
  subtitle: string
  description: string
}> = [
  {
    id: 'track_titles',
    icon: Wand2,
    href: '/admin/tools/track-name-ideas',
    title: 'Track Name Generator',
    subtitle: 'Generate release names from Suno prompts',
    description: 'Generate short release-ready track title ideas from an existing Suno style prompt.'
  },
  {
    id: 'suno_style_prompts',
    icon: Music2,
    href: '/admin/tools/suno-style-prompts',
    title: 'Style Prompt Generator',
    subtitle: 'Transform musical ideas into Suno prompts',
    description: 'Describe a musical idea in free form and receive Suno-ready style and exclude prompts.'
  },
  {
    id: 'prompt_library',
    icon: Library,
    href: '/admin/tools/prompt-management',
    title: 'Prompt Library',
    subtitle: 'Manage reusable Suno prompts',
    description: 'Create, search, edit, and delete reusable Suno style and exclude prompts.'
  }
]

export const ToolsPage = () => {
  const { setMobileMenuItems } = useOutletContext<AdminOutletContext>()

  useEffect(() => {
    setMobileMenuItems(null)
  }, [setMobileMenuItems])

  return (
    <>
      <div className={styles['tools-page-header']}>
        <div className={styles['tools-header-copy']}>
          <h1 className="page-title">Tools</h1>
          <p className="page-subtitle">Creative sandbox for quick admin utilities.</p>
        </div>
      </div>

      <section className={styles['tools-overview-grid']} aria-label="Creative tools">
        {tools.map((tool) => {
          const Icon = tool.icon

          return (
            <Link
              className={styles['tools-overview-card']}
              to={tool.href}
              key={tool.id}
            >
              <span className={styles['tools-overview-icon']}>
                <Icon size={24} />
              </span>
              <strong>{tool.title}</strong>
              <small>{tool.subtitle}</small>
              <p>{tool.description}</p>
            </Link>
          )
        })}
      </section>
    </>
  )
}
